import { useEffect, useRef, useState } from 'react';

export function useInViewDelay({
  delay = 0,
  initialIsInView = false,
}: {
  delay?: number;
  initialIsInView?: boolean;
} = {}) {
  const [isInView, setIsInView] = useState(initialIsInView);
  const timeoutId = useRef<NodeJS.Timeout | undefined>(undefined);

  function onEnter() {
    if (timeoutId.current !== undefined) return;

    if (delay > 0) {
      timeoutId.current = setTimeout(() => setIsInView(true), delay);
      return;
    }

    setIsInView(true);
  }

  function onLeave() {
    killTimeout();
    setIsInView(false);
  }

  function onChange(inView: boolean) {
    if (inView) {
      onEnter();
    } else {
      onLeave();
    }
  }

  function killTimeout() {
    if (timeoutId.current) window.clearTimeout(timeoutId.current);
  }

  useEffect(() => {
    killTimeout();
  }, []);

  return { isInView, onChange, onEnter, onLeave, setIsInView };
}
